import { URLS } from '@wix/da-url';

export enum LlamaType {
  LLAMA = 'llama',
  SUPER = 'super',
  ALBINO = 'albino',
  SUPER_ALBINO = 'super_albino',
  NINJA = 'ninja',
  FANCY = 'fancy',
  KING = 'king',
  SPARTAN = 'spartan',
  WIZARD = 'wizard',
  GOLDEN = 'golden',
  RUNAWAY = 'runaway',
  MYSTERY = 'mystery',
}

export interface LlamaInfo {
  threshold: LlamaType;
  thresholdLabel: string;
  imgSrc: string;
}
export interface LlamaPosition extends LlamaInfo {
  top: number;
  left: number;
}

export interface FormValues {
  backgroundIndex: number;
  llamas: LlamaPosition[];
  unlockedLlamas: LlamaInfo[];
  hasMoreThresholdsToUnlock: boolean;
}

export interface FormState extends FormValues {
  isDragging?: boolean;
  discardedLlamas?: LlamaInfo[];
  dragObject?: LlamaInfo;
}

export const DefaultLlama = {
  threshold: LlamaType.LLAMA,
  thresholdLabel: 'Llama',
  top: 0.8,
  left: 0.5,
  imgSrc: `${URLS.CDN}/badges/llama.gif`,
} as LlamaPosition;

export const MysteryLlama = {
  threshold: LlamaType.MYSTERY,
  thresholdLabel: '???',
  top: 0,
  left: 0,
  imgSrc: `${URLS.CDN}/badges/llama_mystery.gif`,
} as LlamaPosition;
